module.exports = __webpack_public_path__ + "static/media/hotel-doolin.2bbcf73e.png";